/* eslint-disable @typescript-eslint/no-explicit-any */
//export type timeoutOptions = 2000 | 4000 | 6000;
export type ChannelType = 'APP' | 'WEB' | 'WEB_FLOW' | 'UNIVERSAL_LOGIN';

export type BugsnagEnvs = 'development' | 'production' | 'staging';

const APIEnvDEV = [
  'MOCK',
  'DEV1',
  'DEV2',
  'DEV3',
  'DEV4',
  'DEV5',
  'DEV6',
  'DEV7',
  'DEV8',
  'DEV9',
  'DEV10',
] as const;

const APIEnvHML = [
  'HML1',
  'HML2',
  'HML3',
  'HML4',
  'HML5',
  'HML6',
  'HML7',
  'HML8',
  'HML9',
  'HML10',
] as const;

const APIEnvPRD = ['PRD'] as const;

export const DefaultAPIEnvs = {
  development: APIEnvDEV,
  homologation: APIEnvHML,
  production: APIEnvPRD,
};
export type DefaultEnvs = keyof typeof DefaultAPIEnvs;

export type APIEnvs =
  | typeof APIEnvDEV[number]
  | typeof APIEnvHML[number]
  | typeof APIEnvPRD[number];

export type EndPointsNames =
  | 'ApiAccount'
  | 'ApiMain'
  | 'ApiGoogle'
  | 'ApiLiferay'
  | 'ApiAuth0'
  | 'ApiLaunchdarkly'
  | 'ApiUpload'
  | 'ApiFileEnvironment'
  | 'ApiPartner';

export type ApiCredentialsType =
  | 'NOT_CREDENTIALS'
  | 'TOKEN_CREDENTIALS'
  | 'TOKEN_AUTH_USER'
  | 'TOKEN_AUTH_USER_OR_CREDENTIALS'
  | 'TOKEN_X_API_KEY';

export type InitApiType = {
  params?: any | undefined;
  body?: any | undefined;
  headers?: any | undefined;
  pathParameters?: any | undefined;
  proxy?: {
    host: string;
    port: number;
  };
};

export type ApiType =
  | 'Smiles'
  | 'Smiles-Liferay'
  | 'Smiles-Auth0'
  | 'Google'
  | 'Smiles-Launchdarkly'
  | 'Smiles-other'
  | 'Smiles-FileEnvironment';

export type RegionType = 'Brasil';

export type ServiceTypes = {
  environment: APIEnvs;
  logger: boolean;
  timeout: number;
  region: RegionType;
};

export type UserType = {
  memberNumber: number;
  password: string;
};

export type ConfigItemStatus = {
  name: string;
  success: boolean;
  errorMessage: string;
  environmentLD?: string;
};
